import {
  useMediaAdCampaignSetCompanyTagsMutation,
  AdCampaignPureSetCompanyTagsMutationInput,
} from '@shared/api/graphql/generated';
import { BaseMutationResultType, FetchPolicyKeys } from '@shared/api/graphql/types';

export type AdCampaignSetTagResultType = BaseMutationResultType;

export type UseAdCampaignSetTagsType = [
  request: (input: AdCampaignPureSetCompanyTagsMutationInput) => Promise<boolean>,
  result: AdCampaignSetTagResultType,
];

const useAdCampaignSetTags = (): UseAdCampaignSetTagsType => {
  const [createMutation, createMutationResult] = useMediaAdCampaignSetCompanyTagsMutation({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
  });

  const request = async (input: AdCampaignPureSetCompanyTagsMutationInput) => {
    const newTag = await createMutation({
      variables: {
        input,
      },
    });

    return !!newTag.data?.adcampaignSetCompanyTags?.ok;
  };

  const result: AdCampaignSetTagResultType = {
    error: createMutationResult.error,
    loading: createMutationResult.loading,
    called: createMutationResult.called,
  };

  return [request, result];
};

export default useAdCampaignSetTags;
